import { EllipsisOutlined } from "@ant-design/icons"
import { Dropdown, Switch, Typography } from "antd"
import dayjs from "dayjs"

import ButtonComponent from "../../../../Components/Button"
import { titleSortFilters } from "../../../../Components/titleSortFilters"
import { dateFormat } from "../../../../Utils/utils"

const { Text, Link, Paragraph } = Typography

const truncate = (rows) => ({
  ellipsis: { rows, expandable: false },
  style: { margin: 0 }
})

export const perksAdminColumnIconMap = {
  row_number: "hashtag",
  created: "calendar_days",
  partner_name: "business",
  partner_website: "link",
  offer_details: "square_lines",
  description: "square_lines",
  url: "link",
  promocode: "hashtag",
  comment: "messages"
}

export const getColumns = ({ t, onSelectRow, onToggleVisibility }) => ({
  row_number: {
    key: "row_number",
    dataIndex: "row_number",
    sorter: true,
    sortDirections: ["ascend", "descend"],
    title: (state) =>
      titleSortFilters({
        title: "#",
        sorter: true,
        stateData: state,
        key: "row_number"
      }),
    width: 30,
    fixed: "left"
  },
  is_visible: {
    key: "is_visible",
    dataIndex: "is_visible",
    title: "",
    width: 50,
    render: (value, record) => (
      <Switch
        checked={!!value}
        data-testid={`perk-row-visible-switch-${record.id}`}
        onClick={(_, e) => {
          e?.stopPropagation?.()
          onToggleVisibility?.(record)
        }}
      />
    )
  },
  created: {
    key: "created",
    dataIndex: "created",
    sorter: true,
    sortDirections: ["ascend", "descend"],
    defaultSortOrder: "descend",
    title: (state) =>
      titleSortFilters({
        title: t("Created"),
        sorter: true,
        icon: perksAdminColumnIconMap.created,
        stateData: state,
        key: "created"
      }),
    width: 140,
    render: (value) => (value ? dayjs(value).format(dateFormat) : "-")
  },
  partner_name: {
    key: "partner_name",
    dataIndex: "partner_name",
    title: (state) =>
      titleSortFilters({
        title: t("Partner name"),
        icon: perksAdminColumnIconMap.partner_name,
        stateData: state,
        key: "partner_name"
      }),
    width: 200,
    render: (value) => <Text>{value || "-"}</Text>
  },
  partner_website: {
    key: "partner_website",
    dataIndex: "partner_website",
    title: (state) =>
      titleSortFilters({
        title: t("Partner website"),
        icon: perksAdminColumnIconMap.partner_website,
        stateData: state,
        key: "partner_website"
      }),
    width: 200,
    render: (value) =>
      value ? (
        <Link href={value} target="_blank" rel="noopener noreferrer">
          {value.replace(/^https?:\/\//, "")}
        </Link>
      ) : (
        "-"
      )
  },
  offer_details: {
    key: "offer_details",
    dataIndex: "offer_details",
    title: (state) =>
      titleSortFilters({
        title: t("Offer details"),
        icon: perksAdminColumnIconMap.offer_details,
        stateData: state,
        key: "offer_details"
      }),
    width: 260,
    render: (value) => <Paragraph {...truncate(2)}>{value || "-"}</Paragraph>
  },
  description: {
    key: "description",
    dataIndex: "description",
    title: (state) =>
      titleSortFilters({
        title: t("Description"),
        icon: perksAdminColumnIconMap.description,
        stateData: state,
        key: "description"
      }),
    width: 320,
    render: (value) => <Paragraph {...truncate(3)}>{value || "-"}</Paragraph>
  },
  url: {
    key: "url",
    dataIndex: "url",
    title: (state) =>
      titleSortFilters({
        title: t("URL"),
        icon: perksAdminColumnIconMap.url,
        stateData: state,
        key: "url"
      }),
    width: 200,
    render: (value) =>
      value ? (
        <Link href={value} target="_blank" rel="noopener noreferrer">
          {value}
        </Link>
      ) : (
        "-"
      )
  },
  promocode: {
    key: "promocode",
    dataIndex: "promocode",
    title: (state) =>
      titleSortFilters({
        title: t("Promocode"),
        icon: perksAdminColumnIconMap.promocode,
        stateData: state,
        key: "promocode"
      }),
    width: 160,
    render: (value) => value || "-"
  },
  comment: {
    key: "comment",
    dataIndex: "comment",
    title: (state) =>
      titleSortFilters({
        title: t("Comments"),
        icon: perksAdminColumnIconMap.comment,
        stateData: state,
        key: "comment"
      }),
    width: 220,
    render: (value) => (value ? <Paragraph {...truncate(2)}>{value}</Paragraph> : "-")
  }
})

export const getActionColumn = ({ t, onSelectRow }) => ({
  key: "actions",
  dataIndex: "actions",
  title: "",
  width: 56,
  fixed: "right",
  render: (_, record) => (
    <Dropdown
      trigger={["click"]}
      menu={{
        items: [
          {
            key: "comment",
            label: t(record?.comment ? "Edit comment" : "Add comment"),
            "data-testid": `perk-action-comment-${record.id}`
          },
          { key: "edit", label: t("Edit"), "data-testid": `perk-action-edit-${record.id}` },
          {
            key: "delete",
            label: t("Delete"),
            danger: true,
            "data-testid": `perk-action-delete-${record.id}`
          }
        ],
        onClick: ({ key, domEvent }) => {
          domEvent?.stopPropagation?.()
          onSelectRow?.(record, key)
        }
      }}
    >
      <ButtonComponent
        type="text"
        icon={<EllipsisOutlined />}
        onClick={(e) => e.stopPropagation()}
        data-testid={`perk-row-actions-dropdown-${record.id}`}
      />
    </Dropdown>
  )
})
